import { z } from 'zod';
/** Equipment inventory (superadmin module): per client / project / location. */
export const InventoryNode = z.object({
    id: z.uuid(),
    parent_id: z.uuid().nullable(),
    kind: z.string(),
    name: z.string(),
    /** devices directly on this site / in its whole subtree */
    devices: z.number().int(),
    devices_total: z.number().int(),
    assets_total: z.number().int(),
    projects: z.array(z.object({ id: z.uuid(), name: z.string() })),
});
export const InventoryTree = z.object({ items: z.array(InventoryNode) });
export const NominalPower = z.object({
    /** value used by reports (declared, else a confident estimate); null = unknown */
    value_w: z.number().nullable(),
    source: z.enum(['manual', 'legacy', 'estimated', 'unconfirmed', 'insufficient_data']),
    measured_w: z.number().nullable(),
    estimated_w: z.number().nullable(),
    confidence: z.string().nullable(),
    ratio: z.number().nullable(),
    samples: z.number().int().nullable(),
    reason: z.string().nullable(),
    /** declared value disagrees with the estimate */
    mismatch: z.boolean(),
});
export const InventoryItem = z.object({
    id: z.uuid(),
    name: z.string(),
    site_id: z.uuid().nullable(),
    site_name: z.string().nullable(),
    device_type: z.string(),
    protocol: z.string().nullable(),
    model: z.string().nullable(),
    identifiers: z.array(z.object({ scheme: z.string(), value: z.string() })),
    serial: z.string().nullable(),
    firmware: z.string().nullable(),
    lat: z.number().nullable(),
    lon: z.number().nullable(),
    location_source: z.string().nullable(),
    address: z.string().nullable(),
    lifecycle: z.string(),
    presence: z.string(),
    last_seen_at: z.string().nullable(),
    commissioned_on: z.string().nullable(),
    first_seen_at: z.string().nullable(),
    first_seen_source: z.string().nullable(),
    nominal: NominalPower,
    /** device this one is reached through (RTU / concentrator) */
    upstream: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    downstream_count: z.number().int(),
    /** GIS relations of the device (pole, cabinet, …) */
    relations: z.array(z.object({
        kind: z.string(),
        direction: z.enum(['out', 'in']),
        type: z.string(),
        id: z.uuid(),
        name: z.string(),
    })),
    group: z.string().nullable(),
    active_alarms: z.number().int(),
});
export const InventoryList = z.object({
    items: z.array(InventoryItem),
    totals: z.object({
        devices: z.number().int(),
        by_type: z.record(z.string(), z.number().int()),
        by_protocol: z.record(z.string(), z.number().int()),
        nominal_known: z.number().int(),
        nominal_total_w: z.number(),
    }),
});
/** PATCH /api/v1/inventory/devices/:id — facts entered by people (null clears). */
export const InventoryUpdate = z.object({
    commissioned_on: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable()
        .optional(),
    nominal_power_w: z.number().positive().max(5000).nullable().optional(),
    address: z.string().trim().max(300).nullable().optional(),
});
//# sourceMappingURL=inventory.js.map